export const AppointmentFollowUpsFixture = {
  changedMeanwhile: 'changed-meanwhile',
  fullDay: 'full-day',
  limitOff: 'limit-off',
  loadUnavailable: 'load-unavailable',
  restore: 'restore',
  underLimit: 'under-limit',
  writeFails: 'write-fails',
}

export const APPOINTMENT_FOLLOW_UPS_FIXTURES = [
  {
    id: AppointmentFollowUpsFixture.underLimit,
    qaName: 'appointmentFollowUpsUnderLimit',
    text: 'Day under the limit',
  },
  {
    id: AppointmentFollowUpsFixture.fullDay,
    qaName: 'appointmentFollowUpsFullDay',
    text: 'Full day',
  },
  {
    id: AppointmentFollowUpsFixture.limitOff,
    qaName: 'appointmentFollowUpsLimitOff',
    text: 'Daily limit off',
  },
  {
    id: AppointmentFollowUpsFixture.loadUnavailable,
    qaName: 'appointmentFollowUpsLoadUnavailable',
    text: 'Day load not checked',
  },
  {
    id: AppointmentFollowUpsFixture.restore,
    qaName: 'appointmentFollowUpsRestore',
    text: 'Request restored on its due date',
  },
  {
    id: AppointmentFollowUpsFixture.changedMeanwhile,
    qaName: 'appointmentFollowUpsChangedMeanwhile',
    text: 'Due date changed meanwhile',
  },
  {
    id: AppointmentFollowUpsFixture.writeFails,
    qaName: 'appointmentFollowUpsWriteFails',
    text: 'Due date write fails',
  },
]
